// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"SidePopup_popupContainer__12o6b","sidePopup":"SidePopup_sidePopup__1rvVz","actionSection":"SidePopup_actionSection__2RFil","title":"SidePopup_title__u8Ke9"};